import React, { Component } from 'react';

class Product extends Component {
	render() {

		var image = (this.props.image != '') ? <div className="quicklink__img">
			<img src={this.props.image} alt={this.props.name} itemProp="image" />
		</div> : '';

		return (
			<a href={this.props.url} className={"quicklink quicklink--product quicklink--img quicklink--product quicklink--" + this.props.mod  + " elementary"} itemScope itemType="http://schema.org/Product">

				<meta content={this.props.url} itemProp="url" />

				{image}

				<div className="quicklink__content-holder elementary">

					<div className="quicklink__content">

						<h3 className="quicklink__title" itemProp="name">{this.props.name}</h3>

						<div className="quicklink__desc" itemProp="description">
							{this.props.summary}
						</div>

					</div>

				</div>

			</a>
		);
	}
}

export default Product;
